// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__pHbqi","label":"CategoryService_label__3__Q8","location":"CategoryService_location___fsJb"};